module.exports = __webpack_public_path__ + "img/search.aa89c60c.svg";